/*用户模块*/
const User = () => import(/* webpackChunkName: "group-user" */ '../view/user/Index.vue');
const Dynamic = () => import(/* webpackChunkName: "group-user" */ '../view/dynamic/Index');
const UserBasic = () => import(/* webpackChunkName: "group-user" */ '../view/user/BasicInfo.vue');
const CompanyInfo = () => import(/* webpackChunkName: "group-user" */ '../view/user/CompanyInfo.vue');
const UserPassword = () => import(/* webpackChunkName: "group-user" */ '../view/user/PasswordInfo.vue');
const Message = () => import(/* webpackChunkName: "group-user" */ '../view/message/Message');
const Myorder = () => import(/* webpackChunkName: "group-user" */ '../view/myorder/myorder');

export default [
    {
        path: '/user',
        name: 'user',
        component: User,
        meta: {
            title: '用户信息'
        },
        children: [
            {
                path: 'dynamic',
                name: 'dynamic',
                component: Dynamic,
                meta: {
                    title: '公司动态'
                }
            },
            {
                path: 'basic',
                name: 'user-basic',
                component: UserBasic,
                meta: {
                    title: '个人信息'
                }
            },
            {
                path: 'company',
                name: 'user-company',
                component: CompanyInfo,
                meta: {
                    title: '企业信息'
                }
            },
            {
                path: 'password',
                name: 'user-password',
                component: UserPassword,
                meta: {
                    title: '密码修改'
                }
            },
            {
                path: 'message/:id?',
                name: 'user-message',
                component: Message,
                meta: {
                    title: '消息中心'
                }
            },
            {
                path: 'myorder',
                name: 'user-order',
                component: Myorder,
                meta: {
                    title: '订单中心'
                }
            },
        ]
    }
]



// WEBPACK FOOTER //
// ./app/router/router-user.js